"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _antd = require("antd");
require("./activity-indicator.less");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
class ActivityIndicator extends _react.default.Component {
  render() {
    const {
      className,
      children
    } = this.props;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)('activity-indicator', className)
    }, /*#__PURE__*/_react.default.createElement(_antd.Spin, {
      size: "large"
    }), children);
  }
}
exports.default = ActivityIndicator;
//# sourceMappingURL=activity-indicator.js.map